import { IEventSearchParams } from '@/enitites/event'
import { ComputedRef } from 'vue'

export const eventKey = {
  all: ['event'] as const,
  edit: (eventId: number) => [...eventKey.all, 'edit', eventId] as const,
  details: (eventId: number) => [...eventKey.all, 'details', eventId] as const,
  guestList: (eventId: number) => [...eventKey.all, 'guestList', eventId] as const,
  payoutInfo: (eventId: number) => [...eventKey.all, 'payoutInfo', eventId] as const,
  feedbackList: (eventId: number) => [...eventKey.all, 'feedbackList', eventId] as const,
  attendees: (eventId: number) => [...eventKey.all, 'attendees', eventId] as const,
  list: () => [...eventKey.all, 'list'] as const,
  eventsList: (params: ComputedRef<IEventSearchParams>) => [...eventKey.list(), params] as const,
}
